import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMiniCart } from '../../hook/use-mini-cart'
import TagSelectorGroup from '../tag-selector-group'

const CartSelectorView = (props) => {
  const { t } = useTranslation()
  const {
    availableCarts,
    loadings,
    onCartChange,
  } = useMiniCart()
  const selectableCarts = _.size(availableCarts) > 1 ? availableCarts : []
  const options = _.map(
    selectableCarts,
    ({
      key,
      commerceChannel,
      totalItemsCount,
      orderMethod,
      cartId,
    }) => ({
      label: t([
        `ui.miniCart.carts.${_.camelCase(commerceChannel)}`,
        `ui.miniCart.carts.${_.get(orderMethod, 'code', '--No-Order-Method--')}`,
        `ui.miniCart.carts.${_.get(orderMethod, 'commerceType', '--No-Order-Method--')}`,
        `ui.miniCart.carts.${key}`,
      ]),
      value: commerceChannel,
      count: totalItemsCount,
      disabled: _.isEmpty(cartId),
    }),
  )
  const selectedCart = _.find(selectableCarts, 'active')
  return (
    <TagSelectorGroup
      options={options}
      onChange={onCartChange}
      value={_.get(selectedCart, 'commerceChannel')}
      disabled={!_.isEmpty(loadings)}
      {...props}
    />
  )
}

export default CartSelectorView
